$(function() {

    var ticking = false;
    $(window).on("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    });

    function update() {
        var scroll = $(window).scrollTop();
        var start = 10;
        var stop_scroll = 1200;
        var reset = $('.mv_reset').offset().top;

        var scale = 1 - (scroll - start) * 0.0005;
        scale = Math.max(0.5, scale);

        var opacity = 1 - (scroll - start) * 0.001;
        opacity = Math.max(0, opacity);

        if (scroll < stop_scroll) {
            $('#newMv_gallery').css({
                transform: `scale(${scale})`,
                opacity: opacity
            });
        } else if (scroll > reset) {
            $('#newMv_gallery').css({
                transform: 'scale(1)',
                opacity: 0
            });
        }

        ticking = false;
    }

  //mv終わり
  function checkPosition() {
      var scroll = $(window).scrollTop();
      var winH = $(window).height();
      var mvfin = $('.mvfinDiv').offset().top;
      var finSet = mvfin - winH;

      if (finSet > scroll) {
          $('body').removeClass('mvfin');
      } else {
          $('body').addClass('mvfin');
      }
  }

  $(window).on("scroll load resize", function() {
      checkPosition();
  });

  $(window).on('scroll',function(){
    $(".js-inview").each(function(){
      var position = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > position - windowHeight){
        $(this).addClass('isActive');
      }
    });
  });

  $('.js-accordion_title').click(function(){ 
      $(this).next('.js-accordion_inner').slideToggle();
      $(this).toggleClass("open");
  });

  $('a[href^="#"]').click(function () {
    const speed = 600;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top - 30;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  $(window).on("scroll", function() {
    var scroll = $(this).scrollTop();

    if (scroll > 10) {
        $("body").addClass("is-scrolled");
    } else {
        $("body").removeClass("is-scrolled");
    }
  });

});


//PC時fixed要素をbody直下に
window.addEventListener("DOMContentLoaded", () => {
  const elementsToMove = ["fixed-bg-layer", "newMv"];
  
  elementsToMove.forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      document.body.appendChild(el);
    }
  });
});

//背景切り替えアニメーション
const fv = document.getElementById("mv_ttl");

// セクションと背景を自動取得
const sectionEls = Array.from(document.querySelectorAll(".bc__low_contents .bc__low_section"));
const bgEls = Array.from(document.querySelectorAll("#fixed-bg-layer .contents_img"));

const count = Math.min(sectionEls.length, bgEls.length);

function updateBackgrounds() {
  const scrollY = window.scrollY;
  const windowHeight = window.innerHeight;
  const fvHeight = fv.offsetHeight;

  const headerHeight = document.querySelector("header")?.offsetHeight || 0;

  const isPC = window.innerWidth >= 850;

  // PC と SP は別の offset
  const offset = isPC
    ? windowHeight * 0.5
    : windowHeight * 0.10 - headerHeight;

  let activeIndex = -1;

  if (scrollY >= fvHeight) {
    const scrollAdjusted = scrollY - fvHeight + offset;

    for (let i = 0; i < count; i++) {
      const sectionTop = sectionEls[i].offsetTop - fvHeight;

      // margin-bottom を入れている場合はその分だけ延長
      const mb = parseInt(getComputedStyle(sectionEls[i]).marginBottom, 10) || 0;
      const sectionBottom = sectionTop + sectionEls[i].offsetHeight + mb;

      if (scrollAdjusted >= sectionTop && scrollAdjusted < sectionBottom) {
        activeIndex = i;
        break;
      }
    }

    // 最後の fallback（下から戻る時用）
    if (activeIndex === -1) {
      for (let i = count - 1; i >= 0; i--) {
        const sectionTop = sectionEls[i].offsetTop - fvHeight;
        if (scrollAdjusted >= sectionTop) {
          activeIndex = i;
          break;
        }
      }
    }
  }

  // 背景の opacity を切り替え
  bgEls.forEach((el, i) => {
    el.style.opacity = (i === activeIndex) ? "1" : "0";
  });

  // FV 表示中はすべて opacity 0
  if (scrollY < fvHeight) {
    bgEls.forEach(el => el.style.opacity = "0");
  }
}

window.addEventListener("scroll", updateBackgrounds);
window.addEventListener("resize", updateBackgrounds);
updateBackgrounds();
